module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-label": "titlepage",
      "epub:type": "titlepage"
    }
  }, [_c('p', {
    staticClass: "TPT"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page iv. ",
      "epub:type": "pagebreak",
      "id": "pg_iv",
      "role": "doc-pagebreak"
    }
  }, [_c('samp', [_c('b', [_vm._v("2 A.M. IN LITTLE AMERICA")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TPST",
    attrs: {
      "role": "doc-subtitle"
    }
  }, [_c('samp', [_c('b', [_vm._v("a novel")])])]), _vm._v(" "), _c('p', {
    staticClass: "TPAU"
  }, [_c('samp', [_c('b', [_vm._v("KEN KALFUS")])])]), _vm._v(" "), _c('p', {
    staticClass: "TPL"
  }, [_c('samp', [_vm._v("MILKWEED EDITIONS")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c5c1d2c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/title.vue
// module id = 60
// module chunks = 0